/*
 * @Author: yanxia@tencent.com
 * @Date: 2022-03-22 18:39:48
 * @LastEditors: yanxia@tencent.com
 * @LastEditTime: 2022-04-07 19:40:11
 * @Description: file content
 */

import throttle from 'lodash.throttle';
import { useEffect, useState } from 'react';
import { isMobile } from './util';

export const getResizeRatio = () => (isMobile() ? window.innerWidth / 360 : 1);

export const updateFontSize = (resizeRatio: number) => {
  document.documentElement.style.fontSize = `${resizeRatio * 16}px`;
};

type Subscriber = () => void;

const subscribers = new Set<Subscriber>();

let currentResizeRatio = isMobile() ? getResizeRatio() : 1;

if (isMobile()) {
  const onResize = throttle(() => {
    const resizeRatio = getResizeRatio();

    updateFontSize(resizeRatio);
    dispatch(resizeRatio);
  }, 16);
  window.addEventListener('resize', onResize);
}


const dispatch = (resizeRatio: number) => {
  currentResizeRatio = resizeRatio;

  for (const subscriber of Array.from(subscribers.values())) {
    subscriber();
  }
};

export const pxToRem = (px: number) => (isMobile() ? `${px / 16}rem` : `${px}px`);

export const useResizeRatio = () => {
  const [resizeRatio, setResizeRatio] = useState(currentResizeRatio);

  useEffect(() => {
    const subscriber = () => {
      setResizeRatio(currentResizeRatio);
    };

    subscribers.add(subscriber);
    return () => {
      subscribers.delete(subscriber);
    };
  }, []);

  return resizeRatio;
};
